module.exports = __webpack_public_path__ + "/login_ui/img/kh-e985d18c0f99761f8233277682d28d61.svg";